<template>
    <d-container fluid class="main-content-container px-4 pb-4">
        <d-row no-gutters class="page-header py-4">
            <h3 class="page-title">Reconnect Google Analytics V4</h3>
        </d-row>
        <d-row>
            <d-col cols="12" md="10" lg="8" :offset-md="1" :offset-lg="2">
                <d-card class="mt-2">
                    <d-card-body>
                        <GoogleSignIn>
                            <p>Select a Google Analytics V4 account, property and data stream.</p>
                            <ConfigurationList />
                        </GoogleSignIn>
                    </d-card-body>
                </d-card>
            </d-col>
        </d-row>
    </d-container>
</template>

<script>
import {ErrorService, GoogleAnalyticsV4Service} from "@/main";
import notification from "@/mixins/notification";
import Loading from "vue-loading-overlay";
import ConfigurationList from "@/components/ga-v4/ConfigurationList.vue";
import GoogleSignIn from "@/components/integrations/google-analytics-oauth/oauth/GoogleSignIn.vue";

export default {
    mixins: [notification],
    components: {
        GoogleSignIn,
        ConfigurationList,
        Loading,
    },

    data() {
        return {
            form: {
                connectionId: null,
                accountId: null,
                propertyId: null,
                measurementId: null,
                apiSecret: null,
            }
        };
    },

    methods: {
        async reconnect() {
            try {
                await GoogleAnalyticsV4Service.reconnect(
                    this.$route.params.websiteId,
                    this.form.connectionId,
                    this.form.accountId,
                    this.form.propertyId,
                    this.form.measurementId,
                    this.form.apiSecret
                )
                this.showNotification('success', 'Alert', 'Google Analytics V4 successfully reconnected!')
                this.$router.push({ name: 'google-analytics-v4', params: { websiteId: this.$route.params.websiteId }})
            } catch(e) {
                this.showNotification('error-notification', 'Oops! We have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                console.log(e)
            }
        },
    },

    mounted() {
        this.$eventHub.$on("fill-google-analytics-v4-form", (connectionId, accountId, propertyId, measurementId, secret) => {
            this.form.connectionId = connectionId;
            this.form.accountId = accountId;
            this.form.propertyId = propertyId;
            this.form.measurementId = measurementId;
            this.form.apiSecret = secret;

            this.reconnect()
        });
    },
};
</script>
